import React from 'react';

// Other Information - Office Contact No. 36x36 gradient-bordered tile (the frame
// is part of the artwork), glyph exactly as Figma drew it. Gradient ids are
// per-instance (useId) so several icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const OfficeContactIcon = ({ size = 36 }) => {
  const uid = React.useId();
  const g = (n) => `office_contact_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <path
        d="M13 11C11.6667 11 11 12 11 14C11 21.3333 14.6667 25.6667 22 27C24 27 25 26 25 24V22L21 20.5L19 22.5C16.6667 21.5 15.3333 19.1667 15 15.5L17 13.5L15.5 10L13 11Z"
        stroke={`url(#${g(1)})`}
      />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="18" y1="10" x2="18" y2="27" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OfficeContactIcon;
